module.exports = __webpack_public_path__ + "assets/img/1.4953b0a8.png";